import { useState } from "react";
import {
  CancellationDestination,
  CancellationInclude,
  CancellationIncludeKey
} from "../../../interfaces/reservations/Cancellation.types";

const defaultReason = (refund: boolean, uniqueJourneyId: string) =>
  `${refund ? "Rimbursimi pas anulimit" : "Anulim pa rimbursim"} ${uniqueJourneyId}`;

// What comes back and why. An admin cancellation includes every add-on on either destination, so
// only an untick is sent and ticking one again drops it; "Pa rimbursim" starts the choices over.
const useRefundChoices = (uniqueJourneyId: string) => {
  const [overrides, setOverrides] = useState<CancellationInclude>({});
  const [destination, setDestination] = useState<CancellationDestination>("OriginalPayment");
  const [refund, setRefund] = useState(true);
  const [reason, setReason] = useState(defaultReason(true, uniqueJourneyId));

  const setOverride = (key: CancellationIncludeKey, next: boolean) =>
    setOverrides((prev) => {
      const rest = { ...prev };
      delete rest[key];
      return next ? rest : { ...rest, [key]: false };
    });
  const changeDestination = (next: CancellationDestination) => setDestination(next);
  // The prefilled reason follows the choice; one the admin typed stays.
  const changeRefund = (next: boolean) => {
    setOverrides({});
    setRefund(next);
    setReason((prev) =>
      prev === defaultReason(!next, uniqueJourneyId) ? defaultReason(next, uniqueJourneyId) : prev);
  };

  return {
    overrides, setOverride, destination, changeDestination, refund, changeRefund, reason, setReason
  };
};

export default useRefundChoices;
